export interface ICacheEntry {
  url: string | null;
  expiresAt: number;
}

interface IBatchQueue {
  paths: string[];
  timer: ReturnType<typeof setTimeout> | null;
  resolve: ((urls: Map<string, string | null>) => void) | null;
  batch: Promise<Map<string, string | null>> | null;
}

export const urlCache = new Map<string, ICacheEntry>();
export const pendingRequests = new Map<string, Promise<string | null>>();
export const batchQueue: IBatchQueue = {
  paths: [],
  timer: null,
  resolve: null,
  batch: null,
};

export const clearFileUrlCache = (): void => {
  urlCache.clear();
  pendingRequests.clear();
  batchQueue.paths = [];
  if (batchQueue.timer) {
    clearTimeout(batchQueue.timer);
  }
  batchQueue.timer = null;
  batchQueue.resolve = null;
  batchQueue.batch = null;
};
